import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getCustomerType,
  getParticularPage,
  getNext,
  getPrevious,
  createCustomerType,
  updateCustomerType,
  handleSearch,
} from "./thunk";

const initialState = {
  customerTypes: [],
  edit: false,
  customerType: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingCustomerType: false,
  loadingNext: false,
  showCreateModal: false,
  // Form persistence state
  formData: {
    name: "",
    isActive: true,
  },
  activeCustomerTypeId: null,
};

export const customerTypeSlice = createSlice({
  name: "customerType",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    customerTypeEditSuccess: (state, action) => {
      state.edit = true;
      state.customerType = state.customerTypes.find((customerType) => customerType.id === action.payload);
      state.formData = state.customerTypes.find((customerType) => customerType.id === action.payload);
      state.activeCustomerTypeId = action.payload;
    },
    resetCustomerTypeForm: (state, action) => {
      if (action.payload) {
        state.formData = state.customerType;
      } else {
        state.formData = initialState.formData;
        state.activeCustomerTypeId = null;
      }
    },
    saveCustomerTypeForm: (state, action) => {
      state.formData = action.payload;
    },
    clearAllCustomerType: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingCustomerType = false;
      state.customerType = null;
      state.formData = initialState.formData;
      state.activeCustomerTypeId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createCustomerType.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createCustomerType.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createCustomerType.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateCustomerType.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateCustomerType.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateCustomerType.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getCustomerType.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingCustomerType = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCustomerType.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingCustomerType = false;
        state.customerTypes = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCustomerType.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingCustomerType = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  goToPage,
  customerTypeEditSuccess,
  saveCustomerTypeForm,
  resetCustomerTypeForm,
  clearAllCustomerType,
} = customerTypeSlice.actions;

export default customerTypeSlice.reducer;
